export const CUSTOMER_SERVICE_HELP_CENTER_TYPE = 'CUSTOMER_SERVICE';
